import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findUser = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup?`+params,
        method: 'GET'
    })
}
// 单个新增结算账号
export const addTask = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup`,
        method: 'POST',
        data: data
    })
}
// 查询代理商
export const findAgent = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUserList?`+params,
        method: 'GET'
    })
}
// /joins-sales-cloud/v1/accountGroup编辑分组
export const editAcct = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup`,
        method: 'PUT',
        data: data
    })
}
//删除任务
export const delTask = (params) => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/guo_xin/task/`+params,
        method: 'DELETE'
    })
}

// 查询分组明细
export const getGroupDetails = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/details?`+params,
        method: 'GET'
    })
}

// 新增分组明细
export const addGroupDetail = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/details`,
        method: 'POST',
        data: data
    })
}

// 删除分组明细
export const deleteGroupDetails = (ids) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/details/${ids}`,
        method: 'DELETE'
    })
}

// 删除分组
export const deleteAccountGroup = (ids) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/${ids}`,
        method: 'DELETE'
    })
}

// 转移分组明细
export const transferGroupDetail = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/details`,
        method: 'PUT',
        data: data
    })
}